/**
 * Normaliza URIs de imagen remota para avatares (ofertas, listados).
 * Descarta file/content locales y strings basura que en RN/iOS dejan el círculo vacío.
 *
 * @param {unknown} value
 * @returns {string|null}
 */
export function resolveRemoteImageUri(value) {
  if (value == null) return null;
  const uri = String(value).trim();
  if (!uri) return null;
  const lower = uri.toLowerCase();
  if (lower === 'undefined' || lower === 'null' || lower === 'false') return null;
  if (lower.startsWith('file:') || lower.startsWith('content:') || lower.startsWith('ph://')) {
    return null;
  }
  // Google photoURL a veces viene protocol-relative: //lh3.googleusercontent.com/...
  if (uri.startsWith('//')) return `https:${uri}`;
  if (/^https?:\/\//i.test(uri)) return uri;
  return null;
}
